module.exports = __webpack_public_path__ + "2021525:777057f5211ffb5bd912/img/blue-slice.e3edb18.png";